import { getAlert, getDataWithComp, updateData } from "./SamuiUtils";

// เรียกรายงาน Crystal Report
export async function getReport(reportName, docNo) {
    try {
        if (reportName === "pu_water" || reportName === "pu_ice") {
            if (!docNo) {
                getAlert("FAILED", "ไม่พบวันที่สำหรับพิมพ์รายงานเบิกวัสดุ");
                return;
            }
            const link = document.createElement('a');
            const condition = reportName === "pu_ice"
                ? localStorage.getItem("company")
                : "1";
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${reportName}?P_DOC_ID=${encodeURIComponent(docNo)}&P_CONDITION=${condition}`;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            link.click();
            return;
        }

        if (!reportName || !docNo) {
            getAlert("FAILED", "ไม่สามารถเปิดรายงานได้ กรุณาลองใหม่อีกครั้ง");
            return;
        }

        // เก็บไว้ก่อน เพื่อแมร่งมีอีก
        // pklist: { table: 'PKList_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },       // ใบ Picking List

        let tableMap = {
            depos: { table: 'DEPOS_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },            // ใบมัดจำ
            pr: { table: 'PR_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                  // ใบขอซื้อ
            po: { table: 'PO_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                  // ใบสั่งซื้อ
            rec: { table: 'REC_H', filterColumn: 'Rec_No', resultColumn: 'Rec_Id' },                // ใบรับสินค้า
            pay: { table: 'PAY_H', filterColumn: 'Pay_No', resultColumn: 'Pay_Id' },                // ใบสำคัญจ่าย
            qt: { table: 'QT_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                  // ใบเสนอราคา
            so: { table: 'SO_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                  // ใบขาย
            so_receipt: { table: 'SO_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },          // ใบเสร็จรับเงิน (ใบขาย)
            rc: { table: 'SO_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                  // ใบสลิป
            bi1: { table: 'BL_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                 // ใบวางบิล (ต้นฉบับ)
            bi2: { table: 'BL_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },                 // ใบวางบิล (สำเนา)
            inv_water_receipt: { table: 'BL_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },   // ใบเสร็จรับเงิน (ใบวางบิลโรงน้ำ)
            inv_ice_receipt: { table: 'BL_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },     // ใบเสร็จรับเงิน (ใบวางบิลโรงน้ำแข็ง)
            inv1: { table: 'INV_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },               // ใบกำกับภาษี (ต้นฉบับ)
            inv2: { table: 'INV_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },               // ใบกำกับภาษี (สำเนา)
            inv1_so: { table: 'INV_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },
            inv2_so: { table: 'INV_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },
            inv1_bi: { table: 'INV_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },
            inv2_bi: { table: 'INV_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },
            ib: { table: 'WHDoc_Id', filterColumn: 'WHDoc_No', resultColumn: 'WHDoc_Id' },          // ใบยืมสินค้า
            TAX: { table: 'WTAX_H', filterColumn: 'WTAX_Id', resultColumn: 'WTAX_Id' },             // ใบหักภาษี ณ ที่จ่าย
            bl_repeat: { table: 'BL_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },           // ใบวางบิล (กระดาษต่อเนื่อง)
            income_a: { table: 'PKList_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },        // ใบนำส่งรายได้ (ฉบับเต็ม)
            income_b: { table: 'PKList_H', filterColumn: 'Doc_No', resultColumn: 'Doc_Id' },        // ใบนำส่งรายได้ (ฉบับย่อ)
            pd: { table: 'WHDOC_H', filterColumn: 'WHDoc_No', resultColumn: 'WHDoc_Id' },           // ใบส่งสินค้าผลิต
        };

        const isIce = typeof window !== 'undefined' && localStorage.getItem('company') === '2';
        const requestedIncomeA = reportName === 'income_a';
        if (isIce && requestedIncomeA) {
            reportName = 'income_b';
        }

        const reportConfig = tableMap[reportName];
        if (!reportConfig) {
            getAlert("FAILED", "ไม่พบรายงานที่ต้องการ");
            return;
        }

        let pDocId = null;
        let pWhere = null;

        if (reportName === 'tax') {
            pDocId = docNo;
        } else if (requestedIncomeA) {
            pDocId = 1;
            pWhere = docNo;
        } else {
            const { table, filterColumn, resultColumn } = reportConfig;
            const findDocId = await getDataWithComp(table, `AND ${filterColumn} = '${docNo}'`);
            pDocId = findDocId[0]?.[resultColumn];
        }

        if (!pDocId) {
            getAlert("FAILED", "ไม่พบข้อมูลที่ต้องการ");
            return;
        }

        const link = document.createElement('a');

        if (reportName === 'bi1' || reportName === 'bi2') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/bi?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'bi1' ? 'ต้นฉบับ' : 'สำเนา'}`;
        } else if (reportName === 'inv1' || reportName === 'inv2') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${localStorage.getItem('company') === '1' ? 'inv_water' : 'inv_ice'}?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'inv1' ? '1' : '2'}`;
        } else if (reportName === 'inv1_so' || reportName === 'inv2_so') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${localStorage.getItem('company') === '1' ? 'inv_water' : 'inv_ice_so'}?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'inv1_so' ? '1' : '2'}`;
        } else if (reportName === 'inv1_bi' || reportName === 'inv2_bi') {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${localStorage.getItem('company') === '1' ? 'inv_water' : 'inv_ice_bi'}?P_DOC_ID=${pDocId}&P_CONDITION=${reportName === 'inv1_bi' ? '1' : '2'}`;
        } else if (requestedIncomeA) {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${reportName}?P_DOC_ID=${pDocId}&P_CONDITION=${pWhere}`;
        } else {
            link.href = `${process.env.REACT_APP_API_REPORT_URL}/${reportName}?P_DOC_ID=${pDocId}&P_CONDITION=ต้นฉบับ`;
        }

        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();

        // สำหรับหยอดสถานะตอนกดพิมพ์ (ลองทดสอบก่อน บาง Table ยังไม่มี ต้องไปไล่เพิ่มให้ครบ)
        try {
            if (reportConfig && reportConfig.table && reportConfig.filterColumn) {
                const tableToUpdate = reportConfig.table;
                const filterColumn = reportConfig.filterColumn;
                const values = {
                    Printed_Status: 'Y',
                    Printed_Date: new Date().toISOString(),
                    Printed_By: localStorage.getItem('emp_name') || null
                };
                const where = {};
                where[filterColumn] = docNo;
                await updateData(tableToUpdate, values, where);
            }
        } catch (err) {
            console.error('Failed to update printed status:', err);
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        getAlert("FAILED", error.message || error);
    }
};
